import React, { Component, Fragment } from "react"
import { Button, DialogTitle, DialogContent, TextField, DialogActions, Grid, Dialog, TextareaAutosize, Tooltip } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import GetAppIcon from '@material-ui/icons/GetApp';
import AttachmentIcon from '@material-ui/icons/Attachment';
import LinkIcon from '@material-ui/icons/Link';
import { fieldValidation } from "../../../../utils/formValidation"
import { formValues, taskErrorCode } from "../containers/SoftTimeTaskformData"
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from "@material-ui/pickers"
import moment from "moment"
import InfoIcon from '@material-ui/icons/Info';
import axios from 'axios';
import { getLocalStorageInfo,checkApiStatus, format_Commas ,validationMess} from "../../../../utils";
import MomentUtils from "@date-io/moment"
import { backendDateFormat, dayMonthDateFormat ,fieldDMYShort} from "../../../../constants"
import { addStFormApi, deleteStAttachment } from "../apiServices"
import { regexConstants } from "../../../../constants/regEx"
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices"
import LinkFiles from "../../../../shared_elements/components/LinkFiles"
import UploadFile from "../../../../shared_elements/components/UploadFile"
import { assetType, imgStoragePath,specificKey } from "../../../../constants";
import config from "../../../../config";
import { trackActivity } from "../../../../utils/mixpanel";
import { acumenCamo } from "../../../../shared_elements/components";
import { PageLoader } from "../../../../shared_elements";
class StTaskForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: {},
            data: { ...formValues },
            attachments: [],
            newUploadedAttachments: [],
            btnStatus: "",
            open: false,
            deleteAttachmentId: 0,
            showSuccessUpload: false,
            linkFile: false,
            uploadFile: false,
            submitLoader: false,
        }
        this.addStFormApi = addStFormApi.bind(this)
    }

    componentDidMount = () => {
        if (this.props.editFormId) {
            this.fillEditData()
        } else {
            this.getRemovalDateData()
        }
        trackActivity('Soft Time  ADD Modal Opened - CAMO', {
            event_type: 'Modal Opened',
            page_title: 'Soft Time Add Task Form',
        })
    }
    getRemovalDateData = () => {
        const { match } = this.props.props
        globalGetService(`camo/get_removal_date_data/?asset_id=${match.params?.asset}&asset_type_id=${match?.params?.assetType}`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    const { tsn_basic_details, csn_basic_details } = response.data?.data || {}
                    this.setState((prevState) => ({
                        ...prevState,
                        data: { ...prevState.data, tsn: tsn_basic_details, csn: csn_basic_details },
                    }))
                }
            })
    }
    handleOpenFile = () => {
        this.setState({ linkFile: true })
    };

    handleCloseFile = () => {
        this.setState({ linkFile: false })
    };
    handleOpenUploadFile = () => {
        this.setState({ uploadFile: true })
    };
    handleUploadFileCloseFile = () => {
        this.setState({ uploadFile: false })
    };

    onFieldChange = (keyParam, value) => {
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [keyParam]: value,
            },
        }))
    }

    onRestErrorKey = (keyParam) => {
        this.setState((prevState) => ({
            ...prevState,
            error: {
                ...prevState.error,
                [keyParam]: "",
            },
        }))
    }

    handleSubmit = (e) => {
        e.preventDefault()
        if (this.state.submitLoader) {
            return
        }
        let validationInputs = {}
        const { data } = this.state
        validationInputs = {
            ...validationInputs,
            part_number: taskErrorCode["part_number"][fieldValidation({ ...taskErrorCode["part_number_obj"], fieldval: data.part_number, })],
            serial_number: taskErrorCode["serial_number"][fieldValidation({ ...taskErrorCode["serial_number_obj"], fieldval: data.serial_number, })],
            life_limit: taskErrorCode["life_limit"][fieldValidation({ ...taskErrorCode["life_limit_obj"], fieldval: data.life_limit, })],
            // csn: taskErrorCode["csn"][fieldValidation({ ...taskErrorCode["csn_obj"], fieldval: data.csn, })],
            tsn_installation: moment(data.installation_date).isValid() ? taskErrorCode["tsn_installation"][fieldValidation({ ...taskErrorCode["tsn_installation_obj"], fieldval: data.tsn_installation, })] : '',
            csn_installation: moment(data.installation_date).isValid() ? taskErrorCode["csn_installation"][fieldValidation({ ...taskErrorCode["csn_installation_obj"], fieldval: data.csn_installation, })] : '',
            engine_tsn_installation: moment(data.installation_date).isValid() ? taskErrorCode["engine_tsn_installation"][fieldValidation({ ...taskErrorCode["engine_tsn_installation_obj"], fieldval: data.engine_tsn_installation, })] : '',
            engine_csn_installation: moment(data.installation_date).isValid() ? taskErrorCode["engine_csn_installation"][fieldValidation({ ...taskErrorCode["engine_csn_installation_obj"], fieldval: data.engine_csn_installation, })] : '',
        }
         if (data.life_limit) {
			const { error } = this.state
			validationInputs = {
				...validationInputs,
				life_limit: error?.life_limit || '',
			}
		}
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === "" })) {
            const props = this.props.props
            let payload = Object.assign({}, data)
            payload = {
                ...payload,
                asset_id: props.match.params.asset,
                asset_type_id: props.match.params.assetType,
                installation_date: moment(data.installation_date).isValid() ? moment(data.installation_date).format(backendDateFormat) : null,
                life_limit: payload?.life_limit ? data.life_limit.replace(",", "") : null,
                tsn: payload?.tsn || null,
                csn: payload?.csn || null,
                tsn_installation: payload?.tsn_installation || null,
                csn_installation: payload?.csn_installation || null,
                engine_tsn_installation: payload?.engine_tsn_installation || null,
                engine_csn_installation: payload?.engine_csn_installation || null,

            }
            this.setState({ submitLoader: true })
            addStFormApi(payload, props,this.props.openForm).then(async (response) => {
                const uploadId = response.data?.data?.id
                if (uploadId) {
                    await this.uploadFileTest(uploadId, props, false)
                    trackActivity('Soft Time Data Added Successfully - CAMO', {
                        event_type: 'Task Added Successfully',
                        page_title: 'Soft Time',
                        item_id: uploadId ? uploadId : '',
                        request_body: payload ? payload : '',
                        response_msg: response?.data?.message || ''
                    })
                }
                this.setState({ submitLoader: false })
                if (uploadId && this.state.btnStatus !== "addAnother") {
                    this.props.closeAddForm()
                } else {
                    return false
                }

            }).catch(() => {
                this.setState({ submitLoader: false })
            })
            
        } else {
            this.setState({ error: validationInputs })
            trackActivity('Soft Time Data Added Failed - CAMO', {
                event_type: 'Add TASK Failed',
                page_title: 'Soft Time',
                error_source: 'Frontend',
                error_type: validationInputs ? validationInputs : ''
            })
        }
    }
    fillEditData = () => {
        const updateId = this.props.editFormId
        this.setState({ attachments: this.props.attachments })
        if (updateId === undefined || updateId === null) {
            this.setState({
                data: {},
            })
        } else {
            this.setState({
                data: this.props.editFormData,
            })
        }
    }
    isDateValid(dateStr) {
        return !isNaN(new Date(dateStr));
    }
    updateData = async (e) => {
        e.preventDefault()
        let validationInputs = {}
        const { data } = this.state
        validationInputs = {
            ...validationInputs,
            part_number: taskErrorCode["part_number"][fieldValidation({ ...taskErrorCode["part_number_obj"], fieldval: data.part_number, })],
            serial_number: taskErrorCode["serial_number"][fieldValidation({ ...taskErrorCode["serial_number_obj"], fieldval: data.serial_number, })],
            life_limit: taskErrorCode["life_limit"][fieldValidation({ ...taskErrorCode["life_limit_obj"], fieldval: data.life_limit, })],
            // csn: taskErrorCode["csn"][fieldValidation({ ...taskErrorCode["csn_obj"], fieldval: data.csn, })],
            tsn_installation: moment(data.installation_date).isValid() ? taskErrorCode["tsn_installation"][fieldValidation({ ...taskErrorCode["tsn_installation_obj"], fieldval: data.tsn_installation, })] : '',
            csn_installation: moment(data.installation_date).isValid() ? taskErrorCode["csn_installation"][fieldValidation({ ...taskErrorCode["csn_installation_obj"], fieldval: data.csn_installation, })] : '',
            engine_tsn_installation: moment(data.installation_date).isValid() ? taskErrorCode["engine_tsn_installation"][fieldValidation({ ...taskErrorCode["engine_tsn_installation_obj"], fieldval: data.engine_tsn_installation, })] : '',
            engine_csn_installation: moment(data.installation_date).isValid() ? taskErrorCode["engine_csn_installation"][fieldValidation({ ...taskErrorCode["engine_csn_installation_obj"], fieldval: data.engine_csn_installation, })] : '',

        }
        if (data.life_limit) {
			const { error } = this.state
			validationInputs = {
				...validationInputs,
				life_limit: error?.life_limit || '',
			}
		}
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === "" })) {
            delete data.delete_status
			delete data.delete_timestamp
			delete data.deleted_by
			delete data.restore_timestamp
			delete data.restored_by
			delete data.is_restored
            let payload = Object.assign({}, data)
            const props = this.props.props
            payload = {
                ...payload,
                asset_type_id: props.match.params.assetType,
                installation_date: moment(data.installation_date).isValid() ? moment(data.installation_date).format(backendDateFormat) : null,
                life_limit: payload?.life_limit ? data.life_limit.replace(",", "") : null,
                tsn: payload?.tsn || null,
                csn: payload?.csn || null,
                tsn_installation: payload?.tsn_installation || null,
                csn_installation: payload?.csn_installation || null,
                engine_tsn_installation: payload?.engine_tsn_installation || null,
                engine_csn_installation: payload?.engine_csn_installation || null,

            }
            const updateId = this.props.editFormId

            if (updateId) {
                this.uploadFileTest(updateId, props, true)
                trackActivity('Soft Time Data Updated Successfully - CAMO', {
                    event_type: 'Data Updated Successfully',
                    page_title: 'Soft Time',
                    item_id: updateId ? updateId : '',
                    request_body: payload ? payload : ''
                })
            }
            this.props.updateFormData(updateId, payload,props,this.props.openForm,this.props.closeAddForm)
            // this.props.closeAddForm()
            this.setState({ error: validationInputs })
        } else {
            this.setState({ error: validationInputs })
            trackActivity('Soft Time Data Updated Failed - CAMO', {
                event_type: 'Update Data Failed',
                page_title: 'Soft Time',
                error_source: 'Frontend',
                error_type: validationInputs ? validationInputs : ''
            })
        }
    }
    uploadFileTest = async (uploadId, props, isUpdate) => {
        if (this.state.newUploadedAttachments.length > 0) {
            let newAttachmentObj = []
            let formdata = new FormData()
            const module_type_id = 12
            Object.keys(this.state.newUploadedAttachments).map((key, index) => {
                newAttachmentObj.push({
                    file: this.state.newUploadedAttachments[key],
                    file_name: this.state.newUploadedAttachments[key].name,
                    file_type: this.state.newUploadedAttachments[key].type,
                    module_type_id,
                    module_id: uploadId,
                    asset_id: this.props.props.match.params.asset,
                    asset_type_id: this.props.props.match.params.assetType

                })
                formdata.append(
                    "[" + key + "]file",
                    this.state.newUploadedAttachments[key]
                )
                formdata.append(
                    "[" + key + "]file_type",
                    this.state.newUploadedAttachments[key].type
                )
                formdata.append(
                    "[" + key + "]file_name",
                    this.state.newUploadedAttachments[key].name
                )
                formdata.append("[" + key + "]module_id", uploadId)
                formdata.append("[" + key + "]module_type_id", module_type_id)
                formdata.append("[" + key + "]asset_id", this.props.props.match.params.asset)
                formdata.append("[" + key + "]asset_type_id", this.props.props.match.params.assetType)
            })
            this.props.fileUploadData(uploadId, formdata, props, true)
            if (this.state.btnStatus === "addAnother") {
                this.resetBothAttachmentArray()
            }
            if (!isUpdate) {
                this.onSubmitFileLink(uploadId)
                this.props.fileUploadData(uploadId, null, props, false)
            }
        } else {
            if (this.state.btnStatus === "addAnother") {
                this.setState((prevState) => ({
                    ...prevState,
                    data: formValues,
                    attachments: [],
                }))
                document.getElementById("asset-form").reset()
                this.getRemovalDateData()
                this.props.fileUploadData(uploadId, null, props, false)
            } else {
                if (!isUpdate) {
                    this.onSubmitFileLink(uploadId)
                    this.props.fileUploadData(uploadId, null, props, false)
                }
            }
        }
    }

    resetBothAttachmentArray = () => {
        this.setState((prevState) => ({
            ...prevState,
            data: formValues,
            attachments: [],
            newUploadedAttachments: [],
            open: false,
            deleteAttachmentId: 0,
        }))
        document.getElementById("asset-form").reset()
        this.getRemovalDateData()
    }

    onUpload = (files) => {
        const chosenFiles = Array.prototype.slice.call(files)
        for (let i = 0; i < chosenFiles.length; i++) {
            if (chosenFiles[i].size > 52428800) {
                this.props.props.enqueueSnackbar(
                    `${chosenFiles[i].name} Maximum file size should be 50MB.`,
                    {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                    }
                )
                delete chosenFiles[i]
                continue
            } else {
                this.handleUploadFiles(chosenFiles)
                // document.querySelector(".MuiDialog-paper").scrollTop = 800;
                this.setState({
                    showSuccessUpload: true,
                })
                setTimeout(() => {
                    if (this.state.attachments) {
                        this.setState({
                            showSuccessUpload: false,
                        })
                    }
                }, 2500)
            }
        }
    }

    handleUploadFiles = (files) => {
        const uploaded = [...this.state.newUploadedAttachments]
        const existingAttachments = [...this.state.attachments]
        files.some((file) => {
            uploaded.push(file)
        })
        files.map((file) => {
            var objc = {
                id: 0,
                module_id: 0,
                module_type_id: 12,
                file_name: file.name,
                file_type: file.type,
                file: "",
                name: file.name,
                asset_id: this.props.props.match.params.asset,
                asset_type_id: this.props.props.match.params.assetType
            }
            existingAttachments.push(objc)
        })

        this.setState({
            newUploadedAttachments: uploaded,
            attachments: existingAttachments,
        })
    }

    handleClickAttachment = (e, id) => {
        this.setState({ open: true })
        this.setState({ deleteAttachmentId: id })
    }

    handleCloseAttachment = (e) => {
        this.setState({ open: false })
        this.setState({ deleteAttachmentId: 0 })
    }

    deleteAttachmentFile = async (id, file) => {
        if (id !== undefined && id != 0) {
            const props = this.props.props
            deleteStAttachment(id, props)
            var array = [...this.state.attachments]
            array = array.filter((item) => item.id !== id)
            this.setState({ attachments: array, open: false, deleteAttachmentId: 0 })
        } else {
            this.onRemoveCamoFile(file)
        }
    }

    removeAttachment = (e, obj) => {
        var array = [...this.state.attachments]
        var newuploadarray = [...this.state.newUploadedAttachments]

        var filteredArray = []

        newuploadarray.map((file) => {
            if (file.name == obj.file_name && file.type == obj.file_type) {
            } else {
                filteredArray.push(file)
            }
        })
        // Set the state with the new filtered array
        array = array.filter((item) => item !== obj)
        this.setState({
            newUploadedAttachments: filteredArray,
            attachments: array,
        })

    }

    saveAndAddAnother = async (e) => {
        await this.setState({ btnStatus: "addAnother" })
        await this.handleSubmit(e)
    }

    addFormData = async (e) => {
        await this.setState({ btnStatus: "add" })
        this.handleSubmit(e)
    }

    getResponseBack = (file) => {
        const { data, } = this.state
        this.setState({
            data: {
                ...data,
                checklist: file,
            },
        });
    }
    listResponseBack = (file) => {
        if (this.props.actionType === "add" || 'edit') {
            return null
        } else {
            this.props.getResponseBack(file)
        }
    }
    downloadFile = (file) => {
        axios.get(decodeURIComponent(file.path), { timeout: 600000, responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.name);
                document.body.appendChild(link);
                link.click();
            })
    }
    onUnlinkCheckListFile = (checklist, fileId) => {
        const { data } = this.state;
        let payload = {};
        payload.delete = true;
        payload.folder_ids = checklist?.folders?.filter(items => items.type === 'folder').map(file => file.id).filter((id) => id !== fileId).join(',');
        payload.file_ids = checklist?.files?.filter(items => items.type === 'file').map(file => file.id).filter((id) => id !== fileId).join(',');
        globalPutService(`camo/soft_time/${this.props.editFormId}/document-checklists/`, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    const updatedChecklist = { ...checklist };
                    updatedChecklist.files = updatedChecklist.files.filter((file) => file.id !== fileId);
                    updatedChecklist.folders = updatedChecklist?.folders.filter((file) => file.id !== fileId);
                    this.setState({
                        data: {
                            ...data,
                            checklist: updatedChecklist,
                        },
                    });
                }
            });
    }
    onRemoveFile = (file) => {
        const { data } = this.state;
        this.setState({
            data: {
                ...data,
                checklist: data.checklist.filter(item => item.name !== file.name)
            }
        });
    }
    onRemoveCamoFile = (file) => {
        const { attachments } = this.state;
        this.setState({
            attachments: attachments.filter(item => item.file_name !== file.file_name)
        });
    }

    onLinkFile = (file, uuid, type) => {
        if (type == "link" || uuid) {
            const { data } = this.state;
            const folderUUID = [...data.folder_uuid, uuid];
            const updatedChecklist = [...data.checklist, file];

            let uuidData = [];
            let output = [];

            for (const arr of folderUUID) {
                uuidData = uuidData.concat(arr);
            }

            for (const arr of updatedChecklist) {
                output = output.concat(arr);
            }
            this.setState({
                data: {
                    ...data,
                    checklist: output,
                    folder_uuid: uuidData.join("")
                },
            });
        } else {
            this.onUpload(file)
        }

    }

    onSubmitFileLink = (id) => {
        const { data } = this.state;
        if (data?.checklist?.length > 0 && data.checklist.map(item => item.id).filter(item => item)) {
            let payload = {};
            if (data?.checklist.some(item => item.type === 'folder') && data?.checklist.some(item => item.type === 'file')) {
                payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
                payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
            } else if (data?.checklist.some(item => item.type === 'folder')) {
                payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
            } else {
                payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
            }
            globalPutService(`camo/soft_time/${id}/document-checklists/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        this.props.getResponseBack()
                        // this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    } else {
                        this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                });
        }
        if (data?.folder_uuid?.length > 0 && data.folder_uuid) {
            let formData = new FormData();
            formData.append('folder_uuid', data.folder_uuid);
            for (let i = 0; i < data.checklist.filter(item => item instanceof File).length; i++) {
                formData.append('files[]', data.checklist.filter(item => item instanceof File).length && data.checklist.filter(item => item instanceof File)[i]);
            }
            globalPutService(`camo/soft_time/${id}/document-checklists/`, formData)
                .then(response => {
                    if (checkApiStatus(response)) {
                        this.props.getResponseBack()
                    } else {
                        this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                });
        }
    }

    render() {
        const { data, error, attachments, submitLoader } = this.state
           const { assetsDetail } = this.props
        const indexing = assetsDetail?.map((item, index) => item.id).sort((b, a) => b - a)[0] === this.props?.id
        return (
            <Fragment>
                {submitLoader ? <PageLoader /> : null}
                <div id="AmpTaskForm">
                    <DialogTitle>
                        {this.props.formTitle}
                        <CloseIcon
                            onClick={() => { this.props.closeAddForm(); this.listResponseBack() }}
                            className="close-icon"
                        />
                    </DialogTitle>
                    <form
                        id="asset-form"
                        onSubmit={this.props.actionType === "add" ? (e) => this.handleSubmit(e) : (e) => this.updateData(e)}
                    >
                        <DialogContent>
                            <Grid spacing={2} container>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        label="Part Number"
                                        name="part_number"
                                        id="part_number"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.part_number ? data.part_number : ''}
                                        error={error.part_number ? true : false}
                                        inputProps={{ maxLength: 50 }}
                                        helperText={error.part_number ? error.part_number : ""}
                                        onChange={(e) => { this.onFieldChange('part_number', e.target.value); this.onRestErrorKey("part_number") }} // change as per validation sheet
                                        // onChange={(e) => { e.target.value.length <= 50 && (regexConstants.alphanumericWithHyphen.test(e.target.value) || e.target.value === "") && this.onFieldChange('part_number', e.target.value); this.onRestErrorKey("part_number") }}
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        label="Serial Number"
                                        id="serial_number"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.serial_number}
                                        error={error.serial_number ? true : false}
                                        helperText={error.serial_number ? error.serial_number : ""}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(e) => { this.onFieldChange('serial_number', e.target.value); this.onRestErrorKey("serial_number") }} // change as per validation sheet
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                Life Limit
                                                <Tooltip placement='right' title={<span>Allow Keywords - No Limit,or 0 to 99999 </span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        name="life_limit"
                                        id="life_limit"
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        error={error.life_limit ? true : false}
                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.life_limit) && 10 }}
                                        helperText={error.life_limit ? error.life_limit : ""}
                                        value={regexConstants.alphanumespcespclchar.test(data.life_limit) ? data.life_limit : format_Commas(data?.life_limit.replace(/[^0-9.]/g, ''))}
                                        onChange={(e) => {
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("life_limit", e.target.value);
                                                this.setState({ error: {...error, life_limit:e.target.value  === (null || undefined || "")  ? "" : !['NO LIMIT'].includes(e.target.value.toUpperCase()) && 'Allow keywords No limit or 0 to 99999'}, })
                                            } else {
                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('life_limit', e.target.value); this.onRestErrorKey("life_limit")
                                            }
                                        }
                                        }
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                TSN
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        name="tsn"
                                        id="tsn"
                                        error={error.tsn ? true : false}
                                        helperText={error.tsn ? error.tsn : ""}
                                        // value={format_Commas(data?.tsn)}
                                        disabled={this.props.actionType === "edit" ? !indexing : assetsDetail?.length >= 1}
                                        value={regexConstants.alphanumespcespclchar.test(data.tsn) ? data.tsn : format_Commas(data?.tsn.toString().replace(/[^0-9.]/g, ''))}
                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.tsn) && 10 }}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        onChange={(e) => {
                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                            const numericValue = value.replace(/[^\d.]/g, '');
                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("tsn", e.target.value);
                                                this.setState({ error: {...error, tsn:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('TSN',true)}, })

                                            } else if (isValid || value === "") {
                                                this.onFieldChange("tsn", numericValue);
                                                this.setState({ error: {...error, tsn:regexConstants.numberWithDot.test(numericValue) || e.target.value  === (null || undefined || "") ? "" : e.target.value  === null  ? "" : ""}})
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                CSN
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        name="csn"
                                        id="csn"
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        error={error.csn ? true : false}
                                        helperText={error.csn ? error.csn : ""}
                                        disabled={this.props.actionType === "edit" ? !indexing : assetsDetail?.length >= 1}
                                        inputProps={{maxLength:regexConstants.alphanumespcespclchar.test(data.csn) && 9}}
                                        // value={format_Commas(data?.csn)}
                                        value={regexConstants.alphanumespcespclchar.test(data.csn) ? data.csn : format_Commas(data?.csn.toString().replace(/[^0-9.]/g, ''))}
                                        onChange={(e) => {
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("csn", e.target.value);
												this.setState({ error: {...error, csn:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('CSN',false)}, })

                                            } else {
												this.setState({ error: {...error, csn:e.target?.value  === null  || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === ""  ? "" : ""}})
                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('csn', e.target.value); this.onRestErrorKey("csn")
                                            }
                                        }
                                        }
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required={data.installation_date && true}
                                        variant="outlined"
                                        name="tsn_installation"
                                        id="tsn_installation"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                TSN Installation
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        error={error.tsn_installation ? true : false}
                                        helperText={error.tsn_installation ? error.tsn_installation : ""}
                                        value={regexConstants.alphanumespcespclchar.test(data.tsn_installation) ? data.tsn_installation : format_Commas(data?.tsn_installation.replace(/[^0-9.]/g, ''))}
                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.tsn_installation) && 10 }}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        onChange={(e) => {
                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                            const numericValue = value.replace(/[^\d.]/g, '');
                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("tsn_installation", e.target.value);
                                                this.setState({ error: { ...error,tsn_installation:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('TSN Installation',true)}, })
                                                // this.onRestErrorKey("tsn_installation")
                                            } else if (isValid || value === "") {
                                                this.onFieldChange("tsn_installation", numericValue);
											   this.setState({ error: { ...error,tsn_installation:regexConstants.numberWithDot.test(numericValue) || e.target.value  === (null || undefined || "") ? "" : e.target.value  === null  ? "" : ""}})
                                                // this.onRestErrorKey("tsn_installation")
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required={data.installation_date && true}
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                CSN Installation
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        name="csn_installation"
                                        id="csn_installation"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{maxLength:regexConstants.alphanumespcespclchar.test(data.csn_installation) && 9}}
                                        error={error.csn_installation ? true : false}
                                        helperText={error.csn_installation ? error.csn_installation : ""}
                                        value={regexConstants.alphanumespcespclchar.test(data.csn_installation) ? data.csn_installation : format_Commas(data?.csn_installation.toString().replace(/[^0-9.]/g, ''))}
                                        onChange={(e) => {
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("csn_installation", e.target.value);
												this.setState({ error: {...error, csn_installation:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess("CSN Installation",false)}, })
                                            } else {
												this.setState({ error: {...error, csn:e.target?.value  === null  || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === ""  ? "" : ""}})
                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('csn_installation', e.target.value); this.onRestErrorKey("csn_installation")
                                            }
                                        }
                                        }
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required={data.installation_date && true}
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                Engine TSN Installation
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        id="engine_tsn_installation"
                                        error={error.engine_tsn_installation ? true : false}
                                        helperText={error.engine_tsn_installation ? error.engine_tsn_installation : ""}
                                        value={regexConstants.alphanumespcespclchar.test(data.engine_tsn_installation) ? data.engine_tsn_installation : format_Commas(data?.engine_tsn_installation.replace(/[^0-9.]/g, ''))}
                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.engine_tsn_installation) && 10 }}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        onChange={(e) => {
                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                            const numericValue = value.replace(/[^\d.]/g, '');
                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("engine_tsn_installation", e.target.value);
                                                this.setState({ error: {...error, engine_tsn_installation:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('Engine TSN Installation',true)}, })

                                            } else if (isValid || value === "") {
                                                this.onFieldChange("engine_tsn_installation", numericValue);
                                                this.setState({ error: {...error, engine_tsn_installation:regexConstants.numberWithDot.test(numericValue) || e.target.value  === (null || undefined || "") ? "" : e.target.value  === null  ? "" : ""}})

                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item md={4} sm={6} xs={12}>
                                    <TextField
                                        required={data.installation_date && true}
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                Engine CSN Installation
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        name="engine_csn_installation"
                                        id="engine_csn_installation"
                                        inputProps={{maxLength:regexConstants.alphanumespcespclchar.test(data.engine_csn_installation) && 9}}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        error={error.engine_csn_installation ? true : false}
                                        helperText={error.engine_csn_installation ? error.engine_csn_installation : ""}
                                        value={regexConstants.alphanumespcespclchar.test(data.engine_csn_installation) ? data.engine_csn_installation : format_Commas(data?.engine_csn_installation.toString().replace(/[^0-9.]/g, ''))}
                                        onChange={(e) => {
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("engine_csn_installation", e.target.value);
												this.setState({ error: {...error, engine_csn_installation:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('Engine CSN Installation',false)}, })
                                            } else {
												this.setState({ error: {...error, engine_csn_installation:e.target?.value  === null  || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === ""  ? "" : ""}})
                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('engine_csn_installation', e.target.value); this.onRestErrorKey("engine_csn_installation")
                                            }
                                        }
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item md={4} sm={6} xs={12} className="input-calender">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            label="Installation Date"
                                            id="installation_date"
                                            format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
                                            inputVariant="outlined"
                                            fullWidth
                                            disableFuture
                                            onPaste={(event) => event.preventDefault()}
                                            InputLabelProps={{ shrink: true }}
                                            error={error.installation_date ? true : false}
                                            helperText={error.installation_date ? error.installation_date : ""}
                                            value={data.installation_date}
                                            onChange={(data, value) => {
                                                this.onFieldChange(
                                                    "installation_date",
                                                    moment(data).format(backendDateFormat)
                                                )
                                                this.onRestErrorKey("installation_date")
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={8} sm={6} xs={12}>
                                    <TextField
                                        multiline
                                        variant="outlined"
                                        label="Description"
                                        name="description"
                                        id="description"
                                        value={data.description}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(e) => this.onFieldChange("description", e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item md={6} sm={6} xs={12}>
                                    <TextField
                                        label="Remarks"
                                        margin='normal'
                                        variant='outlined'
                                        fullWidth
                                        value={data.remarks}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => this.onFieldChange("remarks", e.target.value)}
                                        rows={3}
                                        multiline
                                        inputProps={{ maxLength: 250 }}
                                    />
                                </Grid>
                                <Grid item md={6} sm={6} xs={12}>
                                    <div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
                                        <ul className="list-inline spacing-list">
                                            <li className="list-inline-item" onClick={this.handleOpenUploadFile} >
                                                <span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
                                            </li>
                                            <li className="list-inline-item" onClick={this.handleOpenFile}>
                                                <span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
                                            </li>
                                        </ul>
                                    </div>
                                </Grid>
                                <Grid id="data-container" spacing={1} container>
                                    <Grid spacing={1} container>
                                        {this.props.actionType === 'add' ?
                                            <div className='checklist-files'>
                                                <ul className='list-inline'>
                                                    {data?.checklist?.map((file) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{file.name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.onRemoveFile(file)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                    {attachments?.map((attachments) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{attachments.file_name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.onRemoveCamoFile(attachments)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                            :
                                            <div className='checklist-files'>
                                                <ul className='list-inline'>
                                                    {data?.checklist?.files?.map((file) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{file.name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                    {(data.checklist?.folders?.length > 0) &&
                                                        data.checklist?.folders.map((file) => {
                                                            return (
                                                                <li className='list-inline-item' key={file.id}>
                                                                    <Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
                                                                        <a href={`${config.domain.records}${assetType[this.props.props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new"><img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Reacords Data Room" /></a>
                                                                    </Tooltip>
                                                                    <span className='file-name'>{file.name}</span>
                                                                    <span className='file-remove'>
                                                                        <CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                                    </span>
                                                                </li>
                                                            );
                                                        })}
                                                    {attachments?.map((attachments) =>
                                                        <li className='list-inline-item'>
                                                            <span className='file-name'>{attachments.file_name}</span>
                                                            <span className='file-remove'>
                                                                <a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
                                                                <CloseIcon onClick={() => this.deleteAttachmentFile(attachments.id, attachments)} color='secondary' fontSize='small' />
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions className="actions-btn">
                            <Button
                                type="button"
                                className="btn btn-primary"
                                disabled={submitLoader}
                                onClick={this.props.actionType === "add" ? (e) => this.addFormData(e) : (e) => this.updateData(e)}
                            >
                                {this.props.actionType === "add" ? "Add" : "Update"}
                            </Button>

                            {this.props.actionType === "add" ? (<Button disabled={submitLoader} onClick={(e) => this.saveAndAddAnother(e)} type="button" className="btn btn-primary" > Save & Add Another </Button>
                            ) : (
                                ""
                            )}
                            <Button type="button" className="btn btn-primary" onClick={() => { this.props.closeAddForm(); this.listResponseBack() }} > Close </Button>
                        </DialogActions>
                        <Dialog open={this.state.linkFile} onClose={this.handleCloseFile} id="htDialog">
                            <LinkFiles
                                handleClose={() => this.handleCloseFile()}
                                uuid={this.props?.uuid?.uuid}
                                editFormId={this.props.editFormId}
                                getResponseBack={(file) => this.getResponseBack(file)}
                                listResponseBack={(file) => this.listResponseBack(file)}
                                actionType={this.props.actionType}
                                onLinkFile={(file, any, type) => this.onLinkFile(file, any, type)}
                                modType="soft_time"
                                uploadFileInfo={data}
                                last_used_folder_uuid={this.props.last_used_folder_uuid_link_document}
                                attachments={attachments}
                                type="link"
                            />
                        </Dialog>
                        <Dialog open={this.state.uploadFile} onClose={this.handleUploadFileCloseFile} id="htDialog">
                            <UploadFile
                                handleClose={() => this.handleUploadFileCloseFile()}
                                uuid={this.props?.uuid?.uuid}
                                editFormId={this.props.editFormId}
                                getResponseBack={(file) => this.getResponseBack(file)}
                                listResponseBack={(file) => this.listResponseBack(file)}
                                actionType={this.props.actionType}
                                onLinkFile={(file, uuid) => this.onLinkFile(file, uuid)}
                                modType="soft_time"
                                uploadFileInfo={data}
                                last_used_folder_uuid={this.props.last_used_folder_uuid}
                                onUpload={(file) => this.onUpload(file)}
                                type="upload"
                                checkbox_last_used_folder_uuid={this.props.checkbox_last_used_folder_uuid}
                                checkbox_last_used_folder_name={this.props.checkbox_last_used_folder_name}
                            />
                        </Dialog>
                    </form>
                </div>
            </Fragment>
        )
    }
}

export default StTaskForm